import { colors } from '@10d/tend-ui-tokens/samolet';

import { IColor } from 'types';

export const TABLE_ENGINEERING_COLORS: IColor = {
  CALL: {
    color: colors.gray0,
    bgcColor: colors.blue600,
    name: 'На проверке',
  },
  ACCEPTED: {
    color: colors.gray0,
    bgcColor: colors.gold600,
    name: 'Готова к заселению',
  },
  EXPLOITATION: {
    color: colors.gray0,
    bgcColor: colors.green600,
    name: 'Передана в эксплуатацию',
  },
  NOT_ACCEPTED: {
    color: colors.gray0,
    bgcColor: colors.red600,
    name: 'Не принята',
  },
  NOT_READY: {
    color: colors.gray0,
    bgcColor: colors.gray400,
    name: 'Не готова к вызову',
  },

  RE_CALL: {
    color: colors.gray0,
    bgcColor: '#13C2C2',
    name: 'Повторный вызов',
  },
  IN_PROGRESS: {
    color: colors.gray0,
    bgcColor: colors.gold600,
    name: 'В ожидании',
  },
};
